import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import Header from "../../components/Header";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DisciplineReport from "./discipline_report";
import AttendanceReport from "./attendance_report";
import DailyAttendanceReport from "./daily_attendance_report";
import MemberAttendanceHistory from "./member_attendance_history";
import TebaPaymentReports from "./teba_payment_reports";

const GenerateReports = () => {
  return (
    <Box m={{ xs: "12px", sm: "16px", md: "20px" }}>
      <Header title="Generate Reports" subtitle="Select a report to generate" />
      <ToastContainer />
      <Box mt={{ xs: 2, sm: 2.5, md: 3 }}>
        <DisciplineReport />
      </Box>
      <Divider sx={{ my: { xs: 3, sm: 4 } }} />
      <Box>
        <AttendanceReport />
      </Box>
      <Divider sx={{ my: { xs: 3, sm: 4 } }} />
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 2 }}>
          Daily Attendance
        </Typography>
        <DailyAttendanceReport />
      </Box>
      <Divider sx={{ my: { xs: 3, sm: 4 } }} />
      <Box>
        <MemberAttendanceHistory />
      </Box>
      <Divider sx={{ my: { xs: 3, sm: 4 } }} />
      <Box>
        <TebaPaymentReports />
      </Box>
    </Box>
  );
};

export default GenerateReports;
